module.exports = __webpack_public_path__ + "img/ic_close_banner.e8b9b9b7.svg";